export default __webpack_public_path__ + "static/media/PPMan - 254.8613729e.jpeg";